<template>
    <div class="stayCourse">
        <ul>
            <li
             class="col col-sm-6 col-md-4 lesson-li"
             v-for="(item, index) in lessonList"
             :key="index">
                <div>
                    <!-- <div class="lessonInfo">
                        <span class="lesson-one">{{ item.name }}</span>
                        <span class="lesson-one">{{ `${item.date} ${hebdomad[item.week - 1]}` }}</span>
                        <span class="lesson-one">{{ `${item.startTime} - ${item.endTime}` }}</span>
                        <span class="lesson-one">{{ item.onlineTeaching? "线上课" : "线下课" }}</span>
                        <div class="lesson-avatar lesson-one">
                            <span class="avatarBox">
                                <img :src="item.pic" alt="">
                            </span>
                            <span>{{ `${item.teacherName}老师` }}</span>
                        </div>
                    </div> -->
                    <div class="lessoncover">
                        <img :src="(item.lesson && item.lesson.pptCover)? item.lesson.pptCover : ''" alt="">
                    </div>
                    <div class="top">
                        <span class="flex">
                            <span>{{ item.lesson?item.lesson.name?item.lesson.name:'':'' }}</span>
                        </span>
                        <span class="flex">
                            <span>{{ `${item.date} ${item.week? hebdomad[item.week - 1] : ''}` }}</span>
                            <span>{{ `${item.startTime}-${item.endTime}` }}</span>
                        </span>
                        <span class="flex">
                            <div>
                                <img :src="item.pic" alt="">
                                <span>{{item.teacherName }}</span>
                                <span class="lesson-one">{{ item.onlineTeaching? "线上课" : "线下课" }}</span>
                                <el-button v-if="item.lesson && item.lesson.prepareList && item.lesson.prepareList.length" type="success" @click="goPrepare(item.lesson)" plain size="mini">预习</el-button>
                            </div>
                        </span>
                        <el-row type="flex" style="width: 100%;" justify="end">
                            
                        </el-row>
                    </div>
                    <div class="Itemfooter">
                        <el-button type="primary" round @click="inClassroomDialogVisible(item)">进入课堂</el-button>
                    </div>
                    
                </div>
                
            </li>
        </ul>
        <span v-if="lessonList.length == 0" class="default">
            <img src="@/assets/icon/notdata.png" alt="">
            暂时没有待上课程
        </span>
        <CodeDialog :lessonId="currentLessonId" ref="codeDialog"></CodeDialog>
    </div>
</template>
<script>
import Header from '@/components/header';
import Foot from '@/components/foot';
import communityApi from "@/request/api/community";
import classApi from '@/request/api/class';
import tencentApi from "@/request/api/tencent";
import Loading from '@/components/loading';
import CodeDialog from '@/components/dialog/codeDialog';
// import { judgmentTime } from '@/utils';

export default {
    components: {
        Loading,
        Header,
        Foot,
        CodeDialog
    },
    data() {
        return {
            lessonList: [],
            centerDialogVisible: false,
            lessonCode: "",
            date: new Date(),
            hebdomad: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
            currentLessonId: "",
            lessonCover: require('@/assets/lessoncover.png')
        }
    },
    created() {
        this.getLessonLit();
    },
    methods: {
        //获取课程列表
        getLessonLit() {
            let params = {
                type: 'scratch'
            };
            communityApi.stuClassSchedule(params, res => {
                if(res.succeed) {
                    this.lessonList = res.data;
                }
                this.$emit('handleLoading');
            })
        },
        // 显示弹框
        stayLessonDialog(item) {
            this.centerDialogVisible = true;
            this.currentLessonId = item.lessonId;
        },
        //进入课堂弹框显示
        inClassroomDialogVisible(item) {
            console.log(item)
            if(item.onlineTeaching) {
                if(location.hostname.indexOf('roborobo') > -1) {
                    this.isOSPullClient(item.scheduleId)
                } else {
                    tencentApi.checkScheduleTime(item.scheduleId, res => {
                        if(res.succeed) {
                            this.$router.push(`/classroom?id=${item.scheduleId}`)
                        }
                    })
                }
                
                // let msg = {
                //     startContent: "开课前10分钟才可进入教室",
                //     endContent: "当前课已过上课时间"
                // };
                // judgmentTime(item.date, item.startTime, item.endTime, msg, () => {
                //     this.isOSPullClient(item.scheduleId)
                // })
            } else {
                communityApi.attendClassByClassCode(item.scheduleId, res => {
                    if(res.succeed) {
                        if(res.data == null || res.data) {
                            this.$router.push({ name: 'sh', query: { lessonId: item.lessonId }});
                        } else {
                            this.$router.push('/sh');
                        }
                    }
                })
            }
        },
        //判断操作系统，拉起客户端
        isOSPullClient(scheduleId) {
            if(scheduleId) {
                classApi.invokVIPCodeData(scheduleId, res => {
                    if(res.succeed) {
                        if(navigator.userAgent.match(/Windows/i)) {
                            window.CallLiveClient(JSON.stringify({
                                materialId: res.data.materialId,
                                materialUrl: res.data.materialUrl,
                                courseId: res.data.courseId,
                                courseName: res.data.courseName,
                                userId: res.data.userId,
                                userName: res.data.userName,
                                userHeadImg: res.data.userHeadImg,
                                userType: res.data.userType,
                                courseType: res.data.courseType,
                                scratchUrl: res.data.scratchUrl,
                                headId: res.data.headId,
                                liveStreamingId: res.data.liveStreamingId,
                                Members: res.data.members,
                                token: res.data.token,
                                pythonZipUrl: res.data.pythonZipUrl? res.data.pythonZipUrl : "",
                                classType: res.data.classType
                            }));
                        // } else if(navigator.userAgent.match(/Macintosh/i)) {
                        }else{
                            window.webkit.messageHandlers.NativeModel.postMessage({
                                materialId: res.data.materialId,
                                materialUrl: res.data.materialUrl,
                                courseId: res.data.courseId,
                                courseName: res.data.courseName,
                                userId: res.data.userId,
                                userName: res.data.userName,
                                userHeadImg: res.data.userHeadImg,
                                userType: res.data.userType,
                                courseType: res.data.courseType,
                                scratchUrl: res.data.scratchUrl,
                                headId: res.data.headId,
                                liveStreamingId: res.data.liveStreamingId,
                                Members: res.data.members,
                                token: res.data.token,
                                pythonZipUrl: res.data.pythonZipUrl? res.data.pythonZipUrl : "",
                                classType: res.data.classType
                            })
                        }
                    }
                })
            }
        },
        //预习
        goPrepare(item) {
            console.log(item)
            this.$store.dispatch('lesson/set_prepareList', item.prepareList);
            this.$router.push(`/resource?name=${item.name}&type=prepare`);
        },
        
    }
}
</script>
<style scoped lang="scss">
ul, li {
    margin-bottom: 0;
}
.lesson-li {
    padding:0 10px;
    margin-bottom: 30px;
    background: #fff;
    >div{
        border-radius: 10px;
        box-shadow: 0 10px 5px rgba(0, 0, 0, .2);
        .top {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            min-height: 110px;
            padding: 10px;
            img {
                width: 35px;
                /* max-height: 35px; */
                border-radius: 50%;
            }
        }
        .Itemfooter{
            text-align: center;
            padding: 8px 0;
        }
    }
    .lessoncover {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        overflow: hidden;
    }
    .lessoncover img{
        width: 100%;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        max-height: 180px;
    }
    /* display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background: #fff;
    padding: 20px 25px;
    margin-bottom: 15px;
    border-radius: 5px; */
}
.lessonInfo {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.lesson-one {
    margin: 0 15px;
}
.lesson-avatar {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.avatarBox {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    margin-right: 5px;
    border-radius: 50%;
    overflow: hidden;

}
.lesson-one img {
    width: 100%;
}
.inClassroomBtn {
    width: 100%;
}
.default  {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 100px;
    color: #8a8a8a;
    font-size: 15px;
}
.default  img {
    width: 80px;
}
@media (min-width: 1020px) and (max-width: 1200px) {
    .lesson-li {
        width: 50%;;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/lesson/component/stayCourse.vue